module.exports = "<button class=\"kuiButton kuiButton--basic\">\n  Button element\n</button>\n\n<hr class=\"guideBreak\">\n\n<input\n  type=\"submit\"\n  class=\"kuiButton kuiButton--basic\"\n  value=\"Submit input element\"\n>\n\n<hr class=\"guideBreak\">\n\n<a href=\"#\" class=\"kuiButton kuiButton--basic\">\n  Anchor element\n</a>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/guide/views/button/button_elements.html
 ** module id = 727
 ** module chunks = 0
 **/